import { render } from "./InvestmentModal.vue?vue&type=template&id=0ac25c1a"
import script from "./InvestmentModal.vue?vue&type=script&lang=js"
export * from "./InvestmentModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__